import { useState } from "react";

export function FieldText({ label, value, type = "text", disabled, onChange, onBlur, testId }) {
  return (
    <label className="block">
      <span className="text-[10.5px] font-semibold uppercase tracking-wider text-[--idc-muted]">{label}</span>
      <input type={type} value={value ?? ""} disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.value)}
        onBlur={(e) => onBlur && onBlur(e.target.value)}
        className="w-full mt-0.5 text-[13px] border border-[--idc-border] rounded px-2 py-1 disabled:bg-[#F8F9FB]"
        data-testid={testId} />
    </label>
  );
}

export function FieldSelect({ label, value, options, disabled, onChange, testId }) {
  return (
    <label className="block">
      <span className="text-[10.5px] font-semibold uppercase tracking-wider text-[--idc-muted]">{label}</span>
      <select value={value} disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="w-full mt-0.5 text-[13px] border border-[--idc-border] rounded px-2 py-1 bg-white disabled:bg-[#F8F9FB]"
        data-testid={testId}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  );
}

export function useForm(initial) {
  const [form, setForm] = useState(initial || {});
  return [form, setForm];
}
